import { LanguageInfo } from "./LanguageInfo";

export class Romanizer {
  hebrewRomanizer: any = null;
  async romanize(language: LanguageInfo, text: string): Promise<string | null> {
    switch (language.code) {
      /** hebrew */
      case "he": {
        if (this.hebrewRomanizer == null)
          this.hebrewRomanizer = await import("hebrew-transliteration");
        return this.hebrewRomanizer.transliterate(text);
      }
      default: {
        return null;
      }
    }
  }
}
